/**
 * <TeacherFilter />
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent <FilterBy />
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import SelectTeacherModal from 'template/Modals/SelectTeacher';
import ResettableInput from 'components/UI/Inputs/ResettableInput';
import Tooltip from 'react-tooltip';
import uniqid from 'uniqid';

class TeacherFilter extends React.Component {
  static propTypes = {
    onReset: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  static defaultProps = {
    value: {}
  }

  constructor(props) {
    super(props);

    this.id = 'teacher-filter_' + uniqid();

    this._chooseItem = this._chooseItem.bind(this);
  }

  _chooseItem() {
    let {
      onChange,
      schoolId,
      selected,
    } = this.props;

    let {
      selectMultiple,
    } = this.props.options;

    SelectTeacherModal({
      schoolId,
      selectMultiple,
      selected,
    }).then((items)=>{
      if (Array.isArray(items)) {
        let IDs = items.map((c)=>{
          return c.id;
        });
        onChange({ items, IDs });
      } else {
        onChange({ items: [items], IDs: [items.id] });
      }
    });
  }

  componentWillMount() {

  }

  render() {
    let {
      onReset,
      value,
    } = this.props;

    let {
      items
    } = this.props.value;
    let {
      disabled,
    } = this.props.options;
    let valueText = ''
    let tooltipText;
    if (items && items.length > 1) {
      valueText = items[0].name + '...';
      tooltipText = items.map((item, key)=>{
        return <div key={key}>{item.name}</div>
      });
    } else if (items && items.length == 1) {
      valueText = items[0].name;
    }

    const disableTooltip = items === undefined || items.length == 1 || disabled;

    return (
      <div className='filter-by-field'>
        <div data-tip data-for={this.id} >
          <ResettableInput
            placeholder={__('All Teachers', 'schedule')}
            value={valueText}
            onReset={onReset}
            onClick={this._chooseItem}
            isDropdown={true} // this will enable caret on the righthand side
            disabled={disabled}
          />
        </div>
        <Tooltip
          id={this.id}
          disable={disableTooltip}
          effect='solid'
          place='bottom'
          getContent={()=> { return tooltipText; }}/>
      </div>
    );
  }
}

export default TeacherFilter;



// WEBPACK FOOTER //
// ./src/template/FilterBy/filters/TeacherFilter.js